import { BaseModel } from 'src/app/shared/models/base.model';

export class Stock extends BaseModel{

    public product_code:string; 
    public image:string; 
    public quant_min: number;
    public quant_total: number;
    public price: number;
    public size_id: number;
    public statuses_id: number;
    public product_id: number;
    public color_id: number;
    public size: string;
    public sizeDescription:string;
    public statusName: string;
    public productName: string;
    public productDescription: string;
    public colorDescription:string;
    public images:any;
    public category:any;
    public subcategory:any;
    public clubColor:any;
    public clubName:any;

    static fromJsonToObject(jsonData:any):Stock{
        return Object.assign(new Stock(),jsonData);
    }
}